import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCommunityAuth } from "../../../contexts/CommunityAuthContext";

export default function CommunityRedirect() {
  const { user, isAdmin } = useCommunityAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate(isAdmin ? "/admin/dashboard" : "/community/profile", {
        replace: true,
      });
    } else {
      navigate("/community/login", { replace: true });
    }
  }, [user, isAdmin, navigate]);

  return (
    <div className="text-center py-20">
      <div className="inline-block animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-primary dark:border-primary/60"></div>
    </div>
  );
}
